import type {
  GenerationReferenceItem,
  GenerationReferenceRoleValue,
  GenerationResourceTypeValue,
} from '@/types/generation-reference';
import { GenerationReferenceRole, GenerationResourceType } from '@/types/generation-reference';

export interface LocalGenerationReferenceToken {
  identity: string;
  display: string;
  start: number;
  end: number;
}

export function buildGenerationReferenceIdentity(
  reference: Pick<GenerationReferenceItem, 'resourceType' | 'resourceId' | 'role'>
): string {
  return `${reference.resourceType}:${reference.resourceId}:${reference.role}`;
}

const RESOURCE_TYPES = new Set<number>(Object.values(GenerationResourceType));
const REFERENCE_ROLES = new Set<string>(Object.values(GenerationReferenceRole));

/** 解析 `resourceType:resourceId:role`；resourceId 本身不含冒号。 */
export function parseGenerationReferenceIdentity(identity: string): {
  resourceType: GenerationResourceTypeValue;
  resourceId: string;
  role: GenerationReferenceRoleValue;
} | null {
  const firstColon = identity.indexOf(':');
  const lastColon = identity.lastIndexOf(':');
  if (firstColon <= 0 || lastColon <= firstColon) return null;

  const resourceType = Number(identity.slice(0, firstColon));
  const resourceId = identity.slice(firstColon + 1, lastColon).trim();
  const role = identity.slice(lastColon + 1).trim();
  if (!RESOURCE_TYPES.has(resourceType) || !resourceId || !REFERENCE_ROLES.has(role)) {
    return null;
  }

  return {
    resourceType: resourceType as GenerationResourceTypeValue,
    resourceId,
    role: role as GenerationReferenceRoleValue,
  };
}
